module.exports = __webpack_public_path__ + "static/media/content-taxi-1.e4c1a118.jpg";